<template>
  <div style="min-height: 150px">
    <div style="padding: 15px 10px;">
      <div class="row-tip">
        <span v-if="address" style="display:inline-block;margin:0 0 20px 0">  配送至：{{ address.province }}  {{ address.city }} {{ address.county }}{{ address.receiptAddress }}</span>
      </div>

      <el-table :data="productTable" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
        <el-table-column prop="productCode" label="销售产品代码" align="left" min-width="150" />
        <el-table-column prop="productSalesName" label="商品名称" align="left" min-width="150" />
        <el-table-column prop="productName" label="规格型号" align="left" min-width="150" />
        <el-table-column prop="counct" label="数量" align="left" width="60">
          <template v-slot="{row}">
            <span>{{ Number(row.productNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productUnit" label="单位" align="left" width="100" />
        <el-table-column prop="productPrice" label="单价" align="right" header-align="left" width="150" />
        <el-table-column prop="productPriceAdd" label="订单金额" align="right" header-align="left" width="150" />
        <!-- <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="left" width="100" /> -->
        <el-table-column prop="productActualPriceAdd" label="实际结算金额" align="right" header-align="left" width="150" />
        <!-- <el-table-column prop="pname" label="是否购买PSC" align="left">
          <template v-slot="{row}">
            {{ row.buyPsc=='Y'?'是':row.buyPsc=='N'?'否':'' }}
          </template>
        </el-table-column> -->
        <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="100">
          <template v-slot="{row}">
            {{ row.expectedDeliveryDate && row.expectedDeliveryDate.substr(0,11) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="taxName" label="税收分类名称" align="left" width="100" />
        <el-table-column prop="taxRate" label="税率" align="left" width="50">
          <template v-slot="{row}">
            {{ row.taxRate }}<span v-show="row.taxRate">%</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="productDesc"
          label="产品配置描述"
          align="left"
          min-width="100"
          fixed="right"
        />
        <!-- <el-table-column prop="serviceDesc" label="服务备注" align="left" width="100" /> -->
      </el-table>
    </div>
  </div>
</template>
<script type="es6">
// import lookserialNumber from './lookserialNumber';
import { getDictData } from '@/API/international';
import { getReceiptAddressByContractId } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  props: {
    productTable: {
      type: Array,
      default: () => { return []; }
    },
    strContractCode: {
      type: String,
      required: true
    },
    specialProduct: {
      type: Number,
      default: () => { return 0; }
    },
    specialCloudDesc: {
      type: String,
      default: () => { return ''; }
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    },
    multiaddress: {
      type: String,
      default: ''
    },
    multiaddressValue: {
      type: String,
      default: ''
    },
    contractId: {
      type: Number,
      default: -1
    },
    // 特殊开票需求默认值
    specialTicketRequirements: {
      type: [Object, String],
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      address: {},
      exportLoading: false,
      // 是否多地址发货
      formData: { multiaddress: '', specialTicketRequirements: null, otherTxet: '' },
      warehouseList: [],
      // 特殊开票需求
      specialInvoicingList: []
    };
  },

  computed: {
    // 定制化产品
    customizationList () {
      return this.tableData.filter((row) => row.customizationOrNot);
    }
  },

  watch: {
    multiaddress: {
      immediate: true,
      handler (newVal) {
        this.formData.multiaddress = newVal;
      }
    },

    specialTicketRequirements: {
      immediate: true,
      handler (newVal) {
        this.setDefaultData(this.specialInvoicingList, newVal);
      }
    },

    contractId: {
      immediate: true,
      handler (val) {
        if (val !== -1) {
          this.initData(val);
        }
      }
    }
  },

  created () {
    this.queryWarehouse();
  },

  methods: {
    queryWarehouse () {
      let params = { dictType: 'desc_of_special_requirements' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.warehouseList = data;
        }
      });
    },
    initData (contractId) {
      getReceiptAddressByContractId(contractId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.address = json.data;
        }
      }).catch(() => {});
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.allNum();
        }
        if (column.label === '订单金额') {
          sums[index] = this.allOrderAmount();
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.allSettlementAmount();
        }
      });
      return sums;
    },
    allNum () {
      let cont = 0;
      if (this.contractType !== '服务订单') {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.counct);
        });
      } else {
        this.tableData.forEach((item) => {
          cont = MathAdd(cont, item.serviceLife);
        });
      }

      // cont = Number(cont).toFixed(2);
      return cont;
    },
    allOrderAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.orderAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    allSettlementAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmountNum);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    stopProp (e) {
      e.stopPropagation();
    },
    // 判断返回的下拉数据类型
    setDefaultData (list, val) {
      if (list.some(row => row.dictValue === val)) {
        this.formData.specialTicketRequirements = val;
      } else {
        if (list.length) {
          this.formData.otherTxet = val;
          this.formData.specialTicketRequirements = '其他特殊需求';
        } else {
          this.formData.specialTicketRequirements = val;
        }
      }
    }
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
.row-tip{
  display: flex;
  align-items: center;

  .form-wrap{
    margin-left: 30px;
    .el-input--mini{
          width: 100px;
          margin-left:10px
    }
  }

  button{
    position: relative;
    top: -10px;
  }
}

.custom-pro-wrap {
  padding: 10px 0;
  color: red;

  .tag-cell {
    margin-right:8px;
  }
}
</style>
